import React, { Component } from 'react';
import Badge from '@material-ui/core/Badge';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import { IFarmer, IMe, IPedido, IProduct, IProject } from '../Library/types';
import Loader from './Material/Loader';
import { withParamsAndNavigate } from './Material/ReactRouter';
import logo from '../Assets/icons/fa-refresh.svg';
import {AddDocument, RemoveDocument, GetDocument, GetDocuments} from '../Library/sp_firebase';
import background from '../Assets/images/agr.jpg';
import itemIcon from '../Assets/images/items.png';
import orderIcon from '../Assets/images/cesta.png';
import ExitApp from '@material-ui/icons/ExitToAppOutlined';
import pedidosIcon from '../Assets/images/pedido.png';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import CreateModal from './Material/CreateDialog';
import Layout from './Layout';
import {farmers} from '../ApiClients/DummyData';
import { cloneDeep, fill, filter, find, findIndex } from 'lodash';
import {readLocalStorage, writeLocalStorage} from '../Library/sp_general';
import { GetViewDefaultType } from '../Library/helpers';
import LogoWhite from '../Assets/icons/abast05.svg';
import Translate from './Material/Traductor';

//import {GetLogoEmpresa} from '../Library/helpers';

const styles = (theme: Theme) => createStyles({
    badge: {
        top: '10px',
        right: '5px',
    }
});

interface IContactProps {
    //history: any;
    //match: any;
    myInfo?: IMe;
    version: string;
    params?:any;
    navigate?:any;
    cart: Array<IProduct>;
    pedido: IPedido;
    addOrRemoveFromCart: Function;
    updateCart: Function;
    checkPermission:Function;
    allowed:boolean;
}

interface IContactState {
    loading: boolean;
    loadbeauty: boolean;
    modalType: number;
    typeAction: number;
    inputText: string;
    creationModalOpen: boolean;
    searchValue: string;
    viewType: number;
    titleModal:string;
}

class Farmers extends Component<IContactProps, IContactState> {
    constructor(props: IContactProps) {
        super(props);
        this.state = {
            loading: true,
            loadbeauty: false,
            modalType: -1,
            typeAction: -1,
            inputText:'',
            creationModalOpen: false,
            searchValue: '',
            viewType: GetViewDefaultType(),
            titleModal: ''
        };
    }

    componentDidMount() {
        this.handleMyInfoChange();
    }

    componentDidUpdate = (prevprops:IContactProps) => {
        if(prevprops.myInfo !== this.props.myInfo)
            this.handleMyInfoChange();
    }

    handleMyInfoChange = () => {
        if(this.props.myInfo === undefined || this.props.myInfo === null)
            return;
        this.props.checkPermission(this.props.myInfo)
        //this.loadData();
    }

    goToFeature=(id: string)=>{
        //this.props.history.push(`/project/${id}/manage`);
        const {params, navigate} = this.props;
        navigate(`/${id}`);
    }
    
    onCloseCreationModal = () => {
        this.setState({ creationModalOpen: false });
    }

    handleCreateModal = (typeAction: number) => {
        switch(typeAction) {
            case 1: // Cuando el modal implica el cierre de sesión de la app
                console.log('voy a cerrar sesión');
                break;
            default:
                break;
        }
    }

    handleExitApp = () =>{
        this.setState({
            inputText: '¿Quiere cerrar la sesión?',
            modalType: 2,
            typeAction: 1,
            creationModalOpen: true
        })
    }
    
    handleItemClick = (farmer: IFarmer, index: number) => {
        this.props.navigate(`/farmer/${farmer.id}`)
    }

    handleOptionClick = (option:number, farmer:IFarmer) => {
        switch(option){
            case 1: // Go to farmer products
                this.props.navigate(`/farmer/${farmer.id}/products`);
                break;
        }
    }

    contact = (viewType:number, me:IMe) => {
        return (
                <table style={{width:'100%', color:'#003B71', lineHeight:2, textAlign:'justify', paddingLeft:20, paddingRight:20}}>
                    <tbody>
                        <tr>
                            <td>
                                <p>
                                    <a>
                                        {Translate(me.language, "label.mission")}
                                    </a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'center'}}>
                                <img width={'auto'} style={{maxWidth:250, backgroundColor:'#fff', borderRadius:'50%'}} src={LogoWhite} alt='vcLogo'
                                
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

        );
    }

    handleSearchChange=(evt:any)=>{
        if(!evt){
            this.setState((prevState, props) =>({
                searchValue: '',
            }),);
        } else {
            this.setState((prevState, props) =>({
                searchValue: evt.target.value,
            }),);
        }
    }

    render() {
        const {myInfo, version, navigate, pedido, params } = this.props;
        const {loadbeauty, searchValue, viewType } = this.state;

        if(myInfo == null)
            console.log('Usuario no autorizado');
            
        return (
            <div>
                {/*TutorialExplication()*/}
                <Layout
                    navigate={navigate}
                    params={params}
                    placeholderSearch={""}
                    badgeAlarms={pedido.cart.length}
                    version={version}
                    searchValue={searchValue}
                    me={myInfo}
                />
                <div className='home-content'>

                    {/*this.home()*/}
                    {loadbeauty || !myInfo?
                        <div style={{marginLeft:'50%',marginTop:'10%'}}>
                            <Loader loading={this.state.loading}/>
                        </div>

                    :
                        <div style={{
                            position: 'absolute',
                            top: 100,
                            left: 0,
                            right: 0,
                            bottom: 25,
                            overflowY: 'auto'
                        }}>
                            {this.contact(viewType, myInfo)}
                        </div>
                    }

                    <CreateModal
                            onCloseCreationModal={this.onCloseCreationModal}
                            isOpen={this.state.creationModalOpen}
                            inputText={this.state.inputText}
                            typeModal={this.state.modalType}
                            action={this.handleCreateModal}
                            typeAction={this.state.typeAction}
                            loadingModal={false}
                            titleModal={this.state.titleModal}
                        />
                </div>
            </div>
        );
    }
}

export default withParamsAndNavigate(Farmers);